"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mostly borrowed from Formik
 * See https://github.com/jaredpalmer/formik/blob/master/src/types.tsx
 * and https://github.com/jaredpalmer/formik/blob/master/src/Formik.tsx
 */
const final_form_1 = require("final-form");
const ramda_1 = require("ramda");
// Transform Yup ValidationError to a more usable object
function yupToFormErrors(yupError) {
    let errors = {};
    for (const error of yupError.inner) {
        if (!errors[error.path]) {
            errors = final_form_1.setIn(errors, error.path, error.message);
        }
    }
    return errors;
}
exports.yupToFormErrors = yupToFormErrors;
// Validate a yup schema.
function validateYupSchema(values, schema, context = {}, sync) {
    const validateData = {};
    for (const k in values) {
        if (values.hasOwnProperty(k)) {
            const key = String(k);
            validateData[key] = values[key] !== "" ? values[key] : undefined;
        }
    }
    return schema[sync ? "validateSync" : "validate"](validateData, {
        abortEarly: false,
        context,
    });
}
exports.validateYupSchema = validateYupSchema;
exports.validateForm = ramda_1.curry((options, values) => {
    const { schema, sync, context } = options;
    return (validateYupSchema(values, schema, context, sync)
        // eslint-disable-next-line promise/prefer-await-to-then
        .then(() => ({})) // No validation errors
        .catch(yupToFormErrors));
});
//# sourceMappingURL=form.js.map